<template>
  <div class="content">
    <h3 ref="pageHeader" :style="{'--width': widthVar}"  class="pageHeader">学生实训课列表</h3>
    <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
        <!-- <el-form-item label="组织结构">
          <OrganDialog ref="organDia1" @getSelect="getSelect1" :level="levell" @handleOrganQuery="handleOrganQuery1"></OrganDialog>
          <el-input v-model="organLabel" placeholder="请选择组织结构" style="width:320px;" @focus="dialogOpen1" @clear="handeleClear1" clearable></el-input>
        </el-form-item> -->
        <!-- <el-form-item label="状态">
          <el-select v-model="formInline.status" clearable placeholder="请选择状态">
            <el-option label="待审核" value="apply"></el-option>
            <el-option label="已通过" value="pass"></el-option>
            <el-option label="已拒绝" value="refuse"></el-option>
          </el-select>
        </el-form-item> -->
        <!-- <el-form-item :label="`所属${$store.state.themeTitle}室`">
          <el-select v-model="formInline.training_name" clearable filterable :placeholder="`请选择所属${$store.state.themeTitle}室`">
            <el-option v-for="item in $store.state.trainRooms" :key="item.id" :label="item.training_name" :value="item.training_name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="学年学期">
          <el-select v-model="formInline.term" clearable filterable placeholder="请选择学年学期">
            <el-option v-for="(item,index) in $store.state.termms" :key="index" :label="item.term" :value="item.term"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="课程名称">
          <el-input v-model="formInline.course_name" clearable placeholder="请输入课程名称"></el-input>
        </el-form-item> -->
        <!-- <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
        </el-form-item> -->
        <!-- <el-form-item>
          <el-button type="primary" @click="handleAdd()">新增</el-button>
        </el-form-item> -->
        <!-- <el-form-item>
          <el-button type="primary" @click="handleExport">{{exportTitle}}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handlePrint">打印</el-button>
        </el-form-item> -->
      </el-form>
    </div>
    <div>
      <custom-table :data="tableData" ref="table" border style="width: 100%">
        <custom-table-column fixed prop="course_name" label="课程名称" width="180">
        </custom-table-column>
        <custom-table-column prop="signed" label="签到状态" width="120">
          <template slot-scope="scope">
            <span v-if="scope.row.signed" style="color:var(--ligtGreen);">已签到</span>
            <span v-else style="color:var(--blue);">未签到</span>
          </template>
        </custom-table-column>
        <custom-table-column fixed prop="training_name" :label="`${$store.state.themeTitle}室名称`" width="160">
        </custom-table-column>
        <custom-table-column prop="term" label="学年学期" width="160">
        </custom-table-column>
        <custom-table-column prop="week" label="周次" width="100">
        </custom-table-column>
        <custom-table-column prop="xq" label="星期" width="100">
        </custom-table-column>
        <custom-table-column prop="sector" label="节次" width="100">
        </custom-table-column>
        <!-- <custom-table-column label="状态" width="150">
          <template slot-scope="scope">
            <span v-if="scope.row.status=='apply'" style="color:var(--blue);">待审核</span>
            <span v-if="scope.row.status=='pass'" style="color:var(--ligtGreen);">已通过</span>
            <span v-if="scope.row.status=='refuse'" style="color:var(--red);">已拒绝</span>
          </template>
        </custom-table-column> -->
        <custom-table-column prop="structure_1" label="所属院系" width="180">
        </custom-table-column>
        <custom-table-column prop="structure_2" label="专业" width="180">
        </custom-table-column>
        <custom-table-column prop="class_name" label="班级名称" width="180">
        </custom-table-column>
        <custom-table-column prop="item_num" label="项目数" width="100">
        </custom-table-column>
        <custom-table-column prop="people_number" label="人数" width="100">
        </custom-table-column>
        <custom-table-column prop="class_hour" label="上课学时数（小时）" width="140">
        </custom-table-column>
        <custom-table-column prop="teacher" label="指导教师" width="120">
        </custom-table-column>
        <custom-table-column prop="class_content" label="课程内容" min-width="220" show-overflow-tooltip>
        </custom-table-column>
        <custom-table-column fixed="right" label="操作" width="80">
          <template slot-scope="scope">
            <el-button @click="handleSign(scope.row)" type="text" size="small">签到</el-button>
          </template>
        </custom-table-column>
      </custom-table>
      <div class="pageLine">
        <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
      </div>
      </div>
    <el-dialog :close-on-click-modal="false"  title="提示" :visible.sync="dialogVisible" width="400px">
      <span>是否删除</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="deleteMethod">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';
import { mixinOrgan } from '@/assets/js/mixin/organization';

export default {
  name: 'trainingRoom',
  mixins: [mixinList, mixinOrgan],
  data() {
    return {
      classRooms: [],
      formInline1: {
        student: '',
        course_name: '',
      },
      tableData1: [],
      total1: 0,
      organLabel: '',
      selectName: '',
      formInline: {
        training_name: '',
        status: '',
        structure_1: '',
        structure_2: '',
        course_name: '',
        term: '',
      },
      rules: {
        student: [{ required: true, message: '请选择学生', trigger: 'change' }],
        content: [{ required: true, message: '请输入总评', trigger: 'blur' }],
        items: [{ required: true, trigger: 'blur' }],
      },
      ruleForm: {
        class_plan_id: '',
        type: 2,
        content: '',
        student: '',
        items: '',
      },
      items: [],
      itemsTep: [],
      scoreDialogVisible: false,
      detailDialogVisible: false,
      levell: [1, 2],
      loading: false,
      type: 'add',
      tableName: '实训日志',
      users: [],
      course_name: '',
      students: [],
    };
  },
  created() {},
  mounted() {
    // this.getList();

    // this.getUsers()
  },
  watch: {
    itemsTep: {
      handler: function (val) {
        this.ruleForm.items = JSON.stringify(val);
      },
      deep: true,
    },
  },
  methods: {
    handleScore(row) {
      this.detailDialogVisible = true;
      this.ruleForm.class_plan_id = row.id;
      this.ruleFormTep.class_plan_id = row.id
      this.formInline1.course_name = row.course_name;
      this.handleQuery1();
    },
    handleSign(row){
      this.confirmBox('warning', `此操作将签到，是否继续`, { id:row.id }, this.setStatus);
    },
    async setStatus(params) {
      let res = await this.$api.instance.interfaceServer(`api/student/course/sign`, 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '签到成功！',
        });
        this.getList();
      }
    },
    async deleteMethod() {
      let params = { id: this.delid };
      let res = await this.$api.delet.deleteCourse(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '删除成功！',
        });
        this.dialogVisible = false;
        this.handleQuery();
      }
    },
    async createMethod() {
      let params = this.$until.deleteNullPrototype(this.ruleForm);
      let res = await this.$api.creat.createClassPlan(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '提交成功！',
        });
        this.clearState();
      }
    },
    async updateMethod() {
      let params = this.$until.easyDeepCopy(this.ruleForm);;
      let res = await this.$api.update.updateClassPlan(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '编辑成功！',
        });
        this.clearState();
      }
    },
    clearState() {
      this.resetForm('ruleForm');
      this.ruleForm = this.ruleFormTep;
      this.scoreDialogVisible = false;
      this.getList1();
    },
    handleClose(tag) {
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
    },
    handleQuery() {
      this.$refs.pageChild.page = 1;
      this.getList();
    },
    async getList() {
      let params = this.$until.deleteNullPrototype(this.formInline);
      params.page = this.$refs.pageChild.page;
      params.size = this.$refs.pageChild.size;
      let res = await this.$api.instance.interfaceServer('api/student/course/list', 'get', params);
      if (res.code == 0 && res.data) {
        this.tableData = res.data.data;
        this.total = res.data.total;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: var(--width);
}
/deep/.custom-table .cell {
  text-overflow: unset;
}
</style>
